"use client";

import { SimilarArtistCard } from "./similar-artist-card";

interface SimilarArtistsGridProps {
  artists: ReadonlyArray<{ id: string; imageUrl: string; name: string }>;
}

export function SimilarArtistsGrid({ artists }: SimilarArtistsGridProps) {
  return (
    <ul className="grid grid-cols-2 gap-x-4 gap-y-6 min-[400px]:grid-cols-3">
      {artists.map((artist) => (
        <li key={artist.id} className="flex justify-center">
          <SimilarArtistCard id={artist.id} imageUrl={artist.imageUrl} name={artist.name} />
        </li>
      ))}
    </ul>
  );
}
